<template>
  <div class="main">
    <vue-headful title="ITT流体技术" description="ITT流体技术" />
    <div class="container">
      <div class="header">
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <div class="main-body">
         <img src="@/assets/main/main2.png" alt="" id="main-img" />
        <p>ITT流体技术的售后服务，为系统和设备的整个生命周期的稳定运行保驾护航，帮助企业实现安全生产，提高生产效率，规避运营风险。</p>
      </div>
      <div class="links">
        <div class="link">
          <a href="tel://4001528008"><img src="@/assets/main/1.1.png" /></a>
        </div>
        <div class="link">
          <a href="https://mp.weixin.qq.com/mp/homepage?__biz=MzUyNDAzNDMzNg==&amp;hid=3&amp;sn=866556d973dc660560c59d45c9039e1d"><img src="@/assets/main/2.2.png" /></a>
        </div>
        <div class="link">
          <a href="/query/#/tools"><img src="@/assets/main/3.3.png" /></a>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {};
  },
  methods: {
    authenticate() {
      // let url = encodeURIComponent(location.href)
      // let appId = 'wxa835709a6a52c7bc'
      // let state = 'stateless'
      // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
    },
  },

  mounted() {
    // this.authenticate();
  },
};
</script>

<style lang="scss" scoped>
@-webkit-keyframes rotation {
  0% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }

  50% {
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg);
  }

  to {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
}

@keyframes rotation {
  0% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }

  50% {
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg);
  }

  to {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
}

.container {
  min-height: calc(100vh - 221px);
  .header {
    height: 15px;
    background-color:  #407cca;
    display: flex;
    .left {
      flex: 1 0 62.4%;
    }
    .right {
      flex: 1 0 37.6%;
      background-color: #ccc;
    }
  }
  .main-body {
    padding-top: 40px;
    color: #656464;
    text-align: center;
    #main-img {
      width: 84%;
      margin: 0 8% 30px;
      animation: rotation 2s linear infinite;
    }
    h3,
    h4 {
      font-size: 18px;
    }

    h4 {
      margin-bottom: 30px;
    }

    p {
      font-size: 13.5px;
      margin: 0 10%;
    }
  }
  .links {
    display: flex;
    margin: 30px 20% 0;
    border-right: 1px dashed #ccc;
    .link {
      text-align: center;
      flex: 1;
      border-left: 1px dashed #ccc;
      img {
        height: calc(169px / 2);
        // width: 70%;
      }
    }
  }
}

// .footer {
//   margin-top: 30px;
//   border-bottom: 15px solid #686767;
//   position: relative;
//   bottom: 0;
//   .top {
//     height: 10px;
//     background: url(../assets/main/footer_bg.png) repeat-x;
//     background-size: 15%;
//   }
//   .content {
//     display: flex;
//     margin: 30px 12%;
//     .qr {
//       flex: 0 1 30%;
//       margin-right: 10px;
//       img {
//         width: 100px;
//       }
//     }
//     .info {
//       flex: 1 0 70%;
//       font-size: 10px;
//       text-align: left;
//       padding-left: 10px;
//       // margin-top: 3px;
//       box-sizing: border-box;
//       h5 {
//         font-size: 11px;
//         color: #1d4f48;
//       }
//       p {
//         line-height: 20px;
//         margin-bottom: 0;
//       }
//     }
//   }
// }
</style>
